module.exports = __webpack_public_path__ + "../public/img/Qr_passo_3.6ea8955e.png";